import {
  AccordionData,
  ChangeEvent,
  ContentType,
} from '@bm-js/atlascloud-shared'
import Input from './Input'
import { Editor } from '@tinymce/tinymce-react'
import { useRef } from 'react'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: ContentType<AccordionData>
  setData: (e: ChangeEvent) => void
}

const AccordionEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null)
  return (
    <>
      <Input
        light
        type='text'
        label={tr(TrKey.accordionEditorTitleLabel)}
        desc={tr(TrKey.accordionEditorTitleDescription)}
        name='title'
        id='title'
        value={content.data.title}
        onChange={setData}
      />
      <p className='m0 label'>{tr(TrKey.accordionEditorContentLabel)}</p>
      {/* TODO: Externalize rich text editor to a single component */}
      <Editor
        onInit={(_evt, editor) => {
          ref.current = editor
        }}
        apiKey='8vx5y7rq8czx2uiyjxz384z1tgv52e698san9yj67z6h9z45'
        initialValue={content.data.content}
        onBlur={() => {
          const e = {
            target: {
              name: 'content',
              value: ref.current.getContent(),
            },
          }
          setData(e)
        }}
        init={{
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],

          toolbar: 'blocks | bold italic underline link  | bullist numlist |',
        }}
      />
      <Select
        light
        label={tr(TrKey.accordionEditorMarginBottomLabel)}
        desc={tr(TrKey.accordionEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.accordionEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default AccordionEditor
